import { createStore } from '@helpers/utils';

export const initialState = {
    promotion_name: null,
    promotion_scheme: null,
    start_date: null,
    end_date: null,
    tfm_id: null,
};

export const initialState2 = {
    promotion_status: null,
    created_at: null,
    total_sku: null,
    total_customer: null,
    id: null,
    is_edit: false,
    is_delete: false,
    row_id: null,
    comment: null,
};

const state = { ...initialState, ...initialState2 };

export const usePromotionClaim = createStore(state);
